import React, { FC } from "react";
import infoIcon from "../../../assets/images/info.png";

interface CostSummaryCardProps {
    BPTotal: number;
    estimatedAlcohol: number;
    estimatedlTotalCost: number;
}

const fmt = (n: number) =>
    n.toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
    });

const CostSummaryCard: FC<CostSummaryCardProps> = ({ BPTotal, estimatedAlcohol, estimatedlTotalCost }) => {

    return (
        <div className="rounded-2xl bg-gray-50 p-4 shadow-sm ring-1 ring-gray-100">
            <div className="divide-y divide-gray-200">
                <SummaryRow label="Service Total" amount={BPTotal} />
                <SummaryRow label="Alcohol Total" amount={estimatedAlcohol} info />
                <SummaryRow label="Event Total" amount={estimatedlTotalCost} info />
            </div>
        </div>
    );
}

export default CostSummaryCard

function SummaryRow({
    label,
    amount,
    info = false,
    bold = false,
}: {
    label: string;
    amount: number;
    info?: boolean;
    bold?: boolean;
}) {
    return (
        <div className="flex items-start justify-between gap-3 py-3 sm:items-center">
            <div className="flex min-w-0 flex-1 items-center gap-1.5 text-sm text-gray-700">
                <span className={`break-words ${bold ? "font-medium" : ""}`}>{label}</span>
                {info && (
                    <InfoIcon className="h-3.5 w-3.5 shrink-0 text-gray-400" />
                )}
            </div>
            <div
                className={`shrink-0 text-right tabular-nums ${
                    bold ? "text-sm font-semibold text-gray-900" : "text-sm text-gray-900"
                }`}
            >
                {amount > 0 ? fmt(amount) : "-"}
            </div>
        </div>
    );
}

function InfoIcon({ className = "h-4 w-4" }: { className?: string }) {
    return (
        <img src={infoIcon} className="w-3 h-3" alt="" />
        // <svg
        //     xmlns="http://www.w3.org/2000/svg"
        //     viewBox="0 0 24 24"
        //     fill="none"
        //     className={className}
        //     aria-hidden="true"
        // >
        //     <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        //     <path
        //         d="M12 10.5v5"
        //         stroke="currentColor"
        //         strokeWidth="1.5"
        //         strokeLinecap="round"
        //     />
        //     <circle cx="12" cy="7.75" r=".9" fill="currentColor" />
        // </svg>
    );
}
